import React from 'react';
import { fmtK, fmtT, BAR_GRADIENTS } from './theme';

export const BarRank = ({ data, metric = 'val', title, gradient = BAR_GRADIENTS.coral }) => {
  if (!data || !data.length) return null;

  const maxVal = Math.max(...data.map(d => metric === 'val' ? d.val : d.qty));

  return (
    <div className="bg-dash-panel border border-dash-line rounded-xl p-4">
      <h3 className="text-sm font-grotesk font-semibold text-dash-ink mb-3">{title}</h3>
      <div className="space-y-1.5">
        {data.map((r, i) => {
          const v = metric === 'val' ? r.val : r.qty;
          const w = maxVal > 0 ? (v / maxVal * 100) : 0;
          return (
            <div key={r.name + i} className="flex items-center gap-2 text-xs">
              <div className="w-[140px] truncate font-grotesk text-dash-ink" title={r.name}>{r.name}</div>
              <div className="flex-1 h-4 bg-dash-bg rounded overflow-hidden">
                <div
                  className={`h-full rounded bg-gradient-to-r ${gradient}`}
                  style={{ width: `${w.toFixed(0)}%` }}
                />
              </div>
              <div className="w-[72px] text-right font-mono text-dash-mut">
                {metric === 'val' ? fmtK(v) : fmtT(v)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
